<section class="profile-settings-page">
  <div class="profile-settings-shell">
    <div class="profile-settings-header">
      <h1 class="profile-settings-header__title">
        {{ "COMPONENTS.PROFILE_SETTINGS.TITLE" | translate }}
      </h1>
    </div>

    <app-card-shell class="profile-settings-frame" padding="none">
      <form
        class="profile-settings-form"
        [formGroup]="formModel.form"
        (ngSubmit)="saveChanges()"
      >
        <div class="profile-settings-scroll">
          <section class="profile-settings-section profile-settings-section--avatar">
            <div class="profile-settings-section__heading">
              <h2>{{ "COMPONENTS.PROFILE_SETTINGS.AVATAR_SECTION" | translate }}</h2>
            </div>

            <div class="profile-settings-avatar">
              <div class="profile-settings-avatar__preview">
                @if (avatarPreviewUrl) {
                  <img
                    class="profile-settings-avatar__image"
                    [src]="avatarPreviewUrl"
                    [alt]="'INPUTS.AVATAR' | translate"
                  />
                } @else if (currentAvatarUrl) {
                  <img
                    class="profile-settings-avatar__image"
                    [src]="currentAvatarUrl"
                    [alt]="'INPUTS.AVATAR' | translate"
                  />
                } @else {
                  <span class="profile-settings-avatar__placeholder no-image">
                    {{ avatarInitials }}
                  </span>
                }
              </div>

              <div class="profile-settings-avatar__content">
                <div class="profile-settings-avatar__actions">
                  <div class="profile-settings-upload">
                    <app-file-upload
                      [fileExtensions]="imageExtensions"
                      [prevExtension]="prevImageExtension"
                      [path]="profileImagePath"
                      [fileTitle]="'avatar'"
                      (uploadedFileEvent)="onUploadFile($event)"
                      (deletedFileEvent)="onDeleteUploadedAvatar()"
                    />
                  </div>

                  <button
                    type="button"
                    class="profile-settings-danger-button profile-settings-avatar__remove"
                    (click)="removeAvatar()"
                    [disabled]="!currentAvatarUrl && !avatarPreviewUrl"
                  >
                    {{ "COMPONENTS.PROFILE_SETTINGS.REMOVE_AVATAR" | translate }}
                  </button>
                </div>

                <p class="profile-settings-avatar__extensions">
                  {{ "COMPONENTS.PROFILE_SETTINGS.SUPPORTED_IMAGE_EXTENSIONS" | translate }}
                  {{ imageExtensionsLabel }}
                </p>
              </div>
            </div>
          </section>

          <section class="profile-settings-form-section">
            <div class="profile-settings-section__heading profile-settings-section__heading--compact">
              <h2>{{ "COMPONENTS.PROFILE_SETTINGS.PERSONAL_SECTION" | translate }}</h2>
            </div>

            <div class="profile-settings-grid">
              <div class="profile-settings-field">
                <label for="name-input" class="profile-settings-field__label">
                  {{ "INPUTS.NAME" | translate }}
                </label>
                <input
                  id="name-input"
                  type="text"
                  class="input-field-lg"
                  [placeholder]="'PLACEHOLDERS.NAME' | translate"
                  [class.is-invalid]="
                    (nameFormControl.touched || nameFormControl.dirty) &&
                    nameFormControl.errors
                  "
                  [class.is-valid]="!nameFormControl.errors"
                  [formControlName]="formModel.fieldNames.name"
                />
                <ng-container
                  *ngTemplateOutlet="
                    validationErrorsTemplate;
                    context: { errors: nameFormControl.errors }
                  "
                ></ng-container>
              </div>

              <div class="profile-settings-field">
                <label for="surname-input" class="profile-settings-field__label">
                  {{ "INPUTS.SURNAME" | translate }}
                </label>
                <input
                  id="surname-input"
                  type="text"
                  class="input-field-lg"
                  [placeholder]="'PLACEHOLDERS.SURNAME' | translate"
                  [class.is-invalid]="
                    (surnameFormControl.touched || surnameFormControl.dirty) &&
                    surnameFormControl.errors
                  "
                  [class.is-valid]="!surnameFormControl.errors"
                  [formControlName]="formModel.fieldNames.surname"
                />
                <ng-container
                  *ngTemplateOutlet="
                    validationErrorsTemplate;
                    context: { errors: surnameFormControl.errors }
                  "
                ></ng-container>
              </div>

              <div class="profile-settings-field">
                <label for="birthdate-input" class="profile-settings-field__label">
                  {{ "INPUTS.BIRTHDATE" | translate }}
                </label>
                <input
                  id="birthdate-input"
                  type="date"
                  class="input-field-lg"
                  [placeholder]="'PLACEHOLDERS.BIRTHDATE' | translate"
                  [class.is-invalid]="
                    (birthDateFormControl.touched || birthDateFormControl.dirty) &&
                    birthDateFormControl.errors
                  "
                  [class.is-valid]="!birthDateFormControl.errors"
                  [formControlName]="formModel.fieldNames.birthDate"
                />
                <ng-container
                  *ngTemplateOutlet="
                    validationErrorsTemplate;
                    context: { errors: birthDateFormControl.errors }
                  "
                ></ng-container>
              </div>

              <div class="profile-settings-field">
                <label for="phone-input" class="profile-settings-field__label">
                  {{ "INPUTS.PHONE" | translate }}
                </label>
                <input
                  id="phone-input"
                  type="tel"
                  class="input-field-lg"
                  [placeholder]="'PLACEHOLDERS.PHONE' | translate"
                  [class.is-invalid]="
                    (phoneNumberFormControl.touched || phoneNumberFormControl.dirty) &&
                    phoneNumberFormControl.errors
                  "
                  [class.is-valid]="!phoneNumberFormControl.errors"
                  [formControlName]="formModel.fieldNames.phoneNumber"
                />
                <ng-container
                  *ngTemplateOutlet="
                    validationErrorsTemplate;
                    context: { errors: phoneNumberFormControl.errors }
                  "
                ></ng-container>
              </div>

              <div class="profile-settings-field">
                <label for="email-input" class="profile-settings-field__label">
                  {{ "INPUTS.EMAIL" | translate }}
                </label>
                <input
                  id="email-input"
                  type="email"
                  class="input-field-lg"
                  [placeholder]="'PLACEHOLDERS.USER_EMAIL' | translate"
                  [class.is-invalid]="
                    (emailFormControl.touched || emailFormControl.dirty) &&
                    emailFormControl.errors
                  "
                  [class.is-valid]="!emailFormControl.errors"
                  [formControlName]="formModel.fieldNames.email"
                />
                <ng-container
                  *ngTemplateOutlet="
                    validationErrorsTemplate;
                    context: { errors: emailFormControl.errors }
                  "
                ></ng-container>
              </div>

              <div class="profile-settings-field">
                <label for="language-input" class="profile-settings-field__label">
                  {{ "INPUTS.LANGUAGE" | translate }}
                </label>
                <select
                  id="language-input"
                  class="input-field-lg profile-settings-field__select"
                  [formControlName]="formModel.fieldNames.interfaceLanguage"
                >
                  @for (language of languages; track language.value) {
                    <option [value]="language.value">{{ language.label }}</option>
                  }
                </select>
              </div>
            </div>
          </section>

          <section class="profile-settings-change-password">
            <a class="profile-settings-inline-action" [routerLink]="['/change-password']">
              {{ "COMPONENTS.PROFILE_SETTINGS.CHANGE_PASSWORD" | translate }}
            </a>
          </section>

          <section class="profile-settings-form-section profile-settings-form-section--api">
            <div class="profile-settings-section__heading profile-settings-section__heading--compact">
              <h2>{{ "COMPONENTS.PROFILE_SETTINGS.API_SECTION" | translate }}</h2>
              <p>{{ "COMPONENTS.PROFILE_SETTINGS.API_HINT" | translate }}</p>
            </div>

            <div class="profile-settings-api">
              <div class="profile-settings-api__field">
                <label for="api-secret-input" class="sr-only">
                  {{ "INPUTS.API_SECRET" | translate }}
                </label>
                <input
                  id="api-secret-input"
                  type="text"
                  class="input-field-lg"
                  [value]="apiSecret"
                  [placeholder]="'PLACEHOLDERS.API_SECRET' | translate"
                  disabled
                />
              </div>

              <button
                type="button"
                class="btn-primary profile-settings-api__button"
                (click)="generateApiSecret()"
                [disabled]="isGeneratingApiSecret"
              >
                {{ "BUTTONS.GENERATE_API_SECRET" | translate }}
              </button>
            </div>
          </section>
        </div>

        <footer class="profile-settings-footer">
          <button
            type="button"
            class="profile-settings-danger-button"
            (click)="deleteProfile()"
          >
            {{ "BUTTONS.DELETE_PROFILE" | translate }}
          </button>

          <button
            type="submit"
            class="btn-primary profile-settings-footer__submit"
            [disabled]="formModel.form.invalid || formModel.form.pristine"
          >
            {{ "BUTTONS.SAVE_CHANGES" | translate }}
          </button>
        </footer>
      </form>
    </app-card-shell>
  </div>
</section>

<ng-template #validationErrorsTemplate let-errors="errors">
  @if (errors) {
    <ul class="invalid-feedback mt-2">
      @if (errors["required"]) {
        <li>{{ "ERRORS.REQUIRED" | translate }}</li>
      }
      @if (errors["email"]) {
        <li>{{ "ERRORS.EMAIL" | translate }}</li>
      }
      @if (errors["minlength"]) {
        <li>
          {{
            "ERRORS.MINLENGTH"
              | translate: { requiredLength: errors["minlength"].requiredLength }
          }}
        </li>
      }
      @if (errors["maxlength"]) {
        <li>
          {{
            "ERRORS.MAXLENGTH"
              | translate: { requiredLength: errors["maxlength"].requiredLength }
          }}
        </li>
      }
      @if (errors["tel"]) {
        <li>{{ "ERRORS.PHONE" | translate }}</li>
      }
    </ul>
  }
</ng-template>

<app-toasts></app-toasts>

<ng-template #dangerTpl>
  {{ callbackError }}
</ng-template>

<ng-template #successTpl>{{
  "MESSAGES.PROFILE_UPDATED" | translate
}}</ng-template>

<ng-template #apiSecretSuccessTpl>{{
  "MESSAGES.API_SECRET_GENERATED" | translate
}}</ng-template>
